import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Carmen, 52',
  city: 'Madrid',
  quote: 'Perdí 8 años de mi rostro en 3 semanas. Mis amigas piensan que me hice un retoque estético, pero es 100% natural. La flacidez de mi cuello prácticamente ha desaparecido.',
  image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?q=80&w=200&auto=format&fit=crop'
}, {
  name: 'Isabel, 47',
  city: 'Barcelona',
  quote: 'Estaba a punto de gastar miles de euros en hilos tensores. Agradezco haber encontrado esta investigación antes. Mis pómulos han recuperado el volumen de mis 30s.',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop'
}, {
  name: 'Lucía, 58',
  city: 'Valencia',
  quote: 'Lo que más me sorprendió no fue solo cómo me veo, sino cómo me siento. La tensión en mi mandíbula desapareció y mi piel tiene un brillo que creía perdido para siempre.',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop'
}];
export function Testimonials() {
  return <section className="max-w-3xl mx-auto px-4 py-16" data-id="element-58">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-12" data-id="element-59">
        <span className="text-xs font-sans font-bold tracking-widest text-gold uppercase mb-3 block" data-id="element-60">
          Evidencia Clínica
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl text-gray-900 font-semibold" data-id="element-61">
          Los Resultados Hablan
        </h2>
      </motion.div>

      <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-3" data-id="element-62">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.2
      }} className="bg-white p-6 rounded-sm border border-gold/10 shadow-sm relative" data-id="element-63">
            <div className="absolute -top-4 left-6 text-6xl font-serif text-gold/20 leading-none" data-id="element-64">
              "
            </div>
            <p className="font-sans text-gray-600 text-sm italic mb-6 relative z-10" data-id="element-65">
              "{t.quote}"
            </p>
            <div className="flex items-center gap-3" data-id="element-66">
              <img src={t.image} alt={t.name} className="w-10 h-10 rounded-full object-cover border border-gold/30" data-id="element-67" />
              <div data-id="element-68">
                <p className="font-serif font-semibold text-gray-900 text-sm" data-id="element-69">
                  {t.name}
                </p>
                <p className="font-sans text-xs text-gray-500" data-id="element-70">{t.city}</p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}